<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="wcrd_fngrprntng"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6 text-uppercase"
      >FAQs

      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <!-- <v-card-title>
            <h4>Visit the following sites to check on warrant status.</h4>
          </v-card-title> -->
          <v-card-text>
            <v-expansion-panels id="subpanels">
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  When is Records open to the public?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Our hours are 8:00 am to 5:30 pm Monday to Saturday.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  Reno Police Dept Main Station Address?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  911 Kuenzli Street Reno, NV 89502
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  How do I obtain a copy of Police Report?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  The Reno Police Department provides a variety of ways that you
                  can request a copy of your Incident Report, Traffic Accident
                  Report or Arrest Report filed within the RPD jurisdiction:
                  <ul>
                    <li>
                      Online Electronic Request -
                      <a href="https://reno.streamlinegov.us/" target="_blank"
                        >City of Reno Public Records Portal</a
                      >(preferred method)
                    </li>
                    <li>In-Person (using the Kiosk at the front desk)</li>
                    <li>U.S. Mail</li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  What is the Records Divison mailing address?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Reno Police Department<br />
                  Attn: Records Section<br />
                  PO BOX 1900<br />
                  Reno, NV 89505
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  Online/In-person Payment Methods?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  <ul>
                    <li>Credit Card (Visa, Mastercard, Discover)</li>
                    <li>Bank Issued Debit Card</li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  How long does it take to get a copy of a report?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  By law, the department has up to five (5) business days to
                  respond to your request from the date of receipt. Every effort
                  will be made to process your request as soon as possible.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  How will the public records be delivered?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Requests for information may be sent online, in-person pick
                  up, or mailed upon receipt of self-addressed stamped envelope.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  What are the fees associated with a request for records?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Please see our
                  <a
                    href="https://renopd.com/formAdmin/content/pdfs_lib/FY25.26_Fee_Schedule_07_2025.pdf"
                    target="_blank"
                    >RECORDS FEE SCHEDULE.</a
                  >
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  How do I request a call for service on an incident?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Go to
                  <a href="https://reno.streamlinegov.us/" target="_blank"
                    >City of Reno Public Records Portal</a
                  >
                  to create an account and submit your request. Under category,
                  <span style="color: rgb(41, 104, 146); font-style: italic"
                    >Choose category 3. General - 911, Dispatch calls, 911
                    Transcripts/Logs.
                  </span>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  How can I request a background request/Immigration or Police
                  Clearance Letter?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Go to
                  <a href="https://reno.streamlinegov.us/" target="_blank"
                    >City of Reno Public Records Portal</a
                  >
                  to create an account and submit your request. Under category,
                  <span style="color: rgb(41, 104, 146); font-style: italic"
                    >Choose 2. Police Department - Background Request. </span
                  ><br />
                  Provide the necessary information. An invoice will be sent to
                  you in the amount of $50.00 per request/letter as per the fee
                  schedule. Once the invoice is paid, the information will be
                  provided to you online.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  Can I get a copy of someone else’s arrest record(s)?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Only the subject of the arrest records may get copies of their
                  record, unless they authorize someone else to specifically
                  obtain the records. Authorization must be written and
                  notarized, and the person authorized must have a valid (not
                  expired) government-issued photo identification. This
                  authorization must mention the name of the person that will be
                  retrieving the records as well.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  Why can’t I have a copy of any report I request? Isn’t it
                  public record?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  All of our records are public records, but per the Donrey vs.
                  Bradshaw decision, not all reports are subject to disclosure
                  at the time of your request. We will do our best to provide
                  you with everything you are entitled to receive. If there is a
                  problem with receiving particular information, please ask to
                  speak with a supervisor. You may be referred to consult with
                  our department’s legal advisor.
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  How do I get my disposition of my case?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  You would have to contact the court of jurisdiction in your
                  case, and those links are provided.
                  <br />
                  <br />
                  <a
                    href="https://www.reno.gov/government/municipal-court/find-your-case"
                    target="_blank"
                    >RENO MUNICIPAL COURT </a
                  ><br />
                  <a
                    href="https://justicecourts.washoecounty.us/Public/default.aspx"
                    target="_blank"
                    >RENO JUSTICE COURT </a
                  ><br />
                  <a
                    href="https://www.washoecourts.com/Query/PersonSearch"
                    target="_blank"
                    >SECOND JUDICIAL DISTRICT COURT</a
                  ><br />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  What is a U-Visa and How can I apply for one?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  The U-Visa was created to provide temporary immigration
                  benefits to undocumented immigrants who are victims of
                  qualifying criminal activity, and to their qualifying family
                  members, as appropriate. <br /><br />

                  The U-Visa is available to undocumented immigrants who have
                  met each of the five criteria listed below: <br /><br /><br />
                  <ol>
                    <li>
                      The person has been the victim of one or more qualifying
                      crimes.
                    </li>
                    <li>
                      The person has suffered substantial physical or mental
                      abuse as a result of having been a victim of one or more
                      qualifying crimes.
                    </li>
                    <li>
                      The person has useful information concerning the crime
                      which occurred.
                    </li>
                    <li>
                      The person has helped, or is likely to help, in the
                      investigation or prosecution of the crime; and
                    </li>
                    <li>
                      The crime committed violated the laws of the United States
                      or occurred in the United States.
                    </li>
                  </ol>
                  <br />

                  The applicant must Go to
                  <a href="https://reno.streamlinegov.us/" target="_blank"
                    >City of Reno Public Records Portal</a
                  >
                  to create an account and submit the request. Under category,
                  <span style="color: rgb(41, 104, 146); font-style: italic"
                    >Choose 2. Police Department –Form I-918.</span
                  >
                  <br />
                  <br />
                  <h3>
                    The applicant must attach a completed Form I-918 B,
                    Supplement B, U Nonimmigrant Status certification to the
                    request for processing.
                  </h3>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- PANEL -->
              <!--<v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  What is the Records Divison mailing address?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  How do I request a call for service on an incident?
                </v-expansion-panel-content>
              </v-expansion-panel>-->

              <!-- PANEL -->
              <v-expansion-panel popout class="mt-4">
                <v-expansion-panel-header
                  class="accent2 white--text text-uppercase"
                >
                  How can I report anonymously?
                  <template v-slot:actions>
                    <v-icon color="white" x-large> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content color="grey lighten-5">
                  Report crimes anonymously at
                  <a href="https://secretwitness.com/">secretwitness.com</a> .
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
@media (min-width: 768px) {
  #subpanels .v-expansion-panel-header {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
  }
  #subpanels .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 44px;
  }
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_faq",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
